export default __webpack_public_path__ + "static/media/wasteless-gen.d89c0243.webp";